import { cloneDeep, isEqual } from 'lodash';
import React, { FC, useCallback, useEffect, useMemo, useRef, useState } from 'react';
import {
  DashboardHeader,
  removeAllFromReferenceData,
  useAppDispatch,
  useAppSelector,
  useEffectOnce,
  CustomRadioForm, CustomForm, CustomButtonGroup, FilterProp, CustomSwitch, CustomBreadCrumbs, CheckBox, DashboardLoader,
} from '../../../../globalUtils/globalExports';

import { useNavigate } from 'react-router-dom';
import { ICustomFormProps, IFormContentProp } from '../../../../globalUtils/CustomForm/CustomForm';
import { useLocation } from 'react-router-dom';
import { Id, toast } from 'react-toastify';
import './UserForm.css'
import { AxiosResponse } from 'axios';
import { Icon, IconWithTooltip } from '../../../../globalUtils/globalIcons';
import { checkCharactersPaste, checkPINCodePaste, checkValidAlphabetDashDot, checkValidAlphaNumericAndMoreSpecialSymbolsWithSpaces, checkValidAlphaNumericOnly, createBreadCrumbProps, keyPressValidationAlphabetDashDot, keyPressValidationAlphaNumericAndMoreSpecialSymbolsWithSpaces, keyPressValidationAlphaNumericOnly, keyPressValidationForCharacters, keyPressValidationForPINCode } from '../../../../globalUtils/globalHooks';

import { isValidPhoneNumber } from 'libphonenumber-js';
import { clearUserRoleTypeReferenceData, fetchChargerLocationReferenceData, fetchChargersByCustomers, fetchCustomerReferenceData, fetchOrgReferenceData, fetchUserRoleTypeReferenceData, getReferenceDataReducer, getUserReducer, userTypes } from '../../../../rmsReduxStore/reduxExports';
import { getAcReferenceDataReducer } from '../../../rmsReduxStore/acReduxExports';
import { fetchAcChargersByCustomers, fetchIndividualUserDetail ,fetchChargersByCustomersByOrg,fetchAcChargersByCustomersByOrg, updateUser, createUser } from '../../../../rmsReduxStore/usersRedux/userCreators';
import { fetchAcChargerLocationReferenceData, fetchAcCustomerReferenceData } from '../../../rmsReduxStore/acReferenceDataRedux/acReferenceDataCreator';
import access from '../../../../auth/service/AccessControl';
import ACDCToggle from '../../../../globalUtils/ACDCToggle/ACDCToggle';


interface UserFormData {
  name: string
  countryCode: string
  mobileNumber: string
  emailId: string
  addressLine1: string
  addressLine2: string
  pinCode: string
  city: string
  state: string
  org: IGeneralReferenceData | null
  role: IGeneralReferenceData | null
  chargerIds: string[]
  acChargerIds : string []
  status: ('Active' | 'Inactive')
  notes: string
  autoAssign: ('Enabled' | 'Disabled'),
  accessToModules: IGeneralReferenceData[] | null,
  accessToAcAndDc : IGeneralReferenceData | null,
}

const AcUserForm: FC = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const { userRoleTypeReferenceData, customerReferenceData, chargerLocationReferenceData, orgReferenceData } = useAppSelector(getReferenceDataReducer);
  const {acCustomerReferenceData,acChargerLocationReferenceData} = useAppSelector(getAcReferenceDataReducer);
  const { chargerListByCustomerByOrg, individualUserDetail, chargerListByCustomer } = useAppSelector(getUserReducer);
  const {acChargerListByCustomerByOrg, acChargerListByCustomer} =  useAppSelector(getUserReducer);
  const [selectedNav, setSelectedNav] = useState<'AC' | 'DC'>(access?.acAndDcAccess() == 'All' ? 'DC': access?.acAndDcAccess());


  const initialFormData: UserFormData = {
    name: '',
    countryCode: '',
    mobileNumber: '',
    emailId: '',
    addressLine1: '',
    addressLine2: '',
    pinCode: '',
    city: '',
    state: '',
    org: null,
    role: null,
    chargerIds: [],
    acChargerIds: [],
    status: 'Active',
    notes: '',
    autoAssign: 'Enabled',
    accessToModules: null,
    accessToAcAndDc: null,
  }
  const [dataList, setDataList] = useState<string[]>([])
  const [acDataList, setAcDataList] = useState<string[]>([])
  const [userFormData, setUserFormData] = useState(initialFormData);
  const [mode, setMode] = useState(location?.state?.mode || 'View')
  const [selectedRadioOption, setSelectedRadioOption] = useState('SelectChargers');
  const [acselectedRadioOption ,setAcSelectedRadioOption] = useState('SelectChargers');
  const [selectedChargers, setSelectedChargers] = useState<string[]>();   // undefined when the UserForm is opened
  const [selectedAcChargers,setAcSelectedChargers] = useState<string[]>();
  const [chargerCheckboxStates, setChargerCheckboxStates] = useState<string[]>([]);
  const  [acChargerCheckboxStates,setAcChargerCheckboxStates] = useState<string[]>([]);
  const [chargersChipValues, setChargersChipValues] = useState<string[]>([]);
  const [acChargersChipValues,setAcChargersChipValues] = useState<string[]>([]);
  const [isSelectAllChargersChecked, setIsSelectAllChargersChecked] = useState(false);
  const [isSelectAllAcChargersChecked, setIsSelectAllAcChargersChecked ]= useState(false);


  // const [initialChargerByCustomers, setInitialChargerByCustomer] = useState<IChargerByCustomer[] | null>([])
  const [showLoader, setShowLoader] = useState(false);
  const [mobileError, setMobileError] = useState('');
  const initialFormDataRef = useRef<UserFormData>(initialFormData)
  const [filters, setFilters] = useState<InnerFilterState[]>(
    [{
      key: 'customer',
      value: null
    }, {
      key: 'location',
      value: null
    }

  ])
  const [acFilters, setAcFilters] = useState<InnerFilterState[]>(
    [{
      key: 'customer',
      value: null
    }, {
      key: 'location',
      value: null
    }
  ])


  const moduleAccessReferenceData = [
    {id: 'aiSupportCenter:*', value: 'aiSupportCenter:*', name: 'AI Smart Assist', label: 'AI Smart Assist'},
    {id: 'aiInsights:*', value: 'aiInsights:*', name: 'AI Insights', label: 'AI Insights'},
    {id: 'moduleAccessProvider:*', value: 'moduleAccessProvider:*', name: 'Module Access', label: 'Module Access'},
    {id: 'aiSupportCenter.documentation:*', value: 'aiSupportCenter.documentation:*', name: 'AI Support Center Documentation', label: 'AI Support Center Documentation'},
    {id: 'report.uptimeReports:*', value: 'report.uptimeReports:*', name: 'Uptime Reports', label: 'Uptime Reports'},
    {id: 'advanceRuleEngine:*', value: 'advanceRuleEngine:*', name: 'Advanced Rule Engine', label: 'Advanced Rule Engine'},
    {id: 'userManagement:*', value: 'userManagement:*', name: 'User Management', label: 'User Management'}
  ]
  const accessToAcAndDcReferenceData = [
    {id: 'All', value: 'All', name: 'All', label: 'Both AC and DC'},
    {id: 'DC', value: 'DC', name: 'DC', label: 'Only DC'},
    {id: 'AC', value: 'AC', name: 'AC', label: 'Only AC'}
  ]
//clearing the role when no org selected
  useEffect(()=>{
     if(!userFormData.org)dispatch(clearUserRoleTypeReferenceData())
  },[userFormData.org])

  useEffectOnce(() => {
    setMode(location?.state?.mode || 'View')
    if (location?.state?.rowData) {
      setUserFormData({
        ...userFormData,
        name: location?.state?.rowData?.name,
        emailId: location?.state?.rowData?.emailId
      })
      chargerListCallback?.(location?.state?.rowData?.orgId)
      acChargerListCallback?.(location?.state?.rowData?.orgId)
      dispatch(fetchUserRoleTypeReferenceData({ orgId: location?.state?.rowData?.orgId }));
    }
    dispatch(fetchChargersByCustomers());
    dispatch(fetchAcChargersByCustomers());
    dispatch(fetchCustomerReferenceData());
    dispatch(fetchAcCustomerReferenceData());
    dispatch(fetchChargerLocationReferenceData());
    dispatch(fetchAcChargerLocationReferenceData());
    dispatch(fetchOrgReferenceData());
    if (mode && location?.state?.userId) {
      dispatch(fetchIndividualUserDetail({ userId: location?.state?.userId, }))
    }
    //BugFix : This is removed because when state is cleared chargerListByCustomer was null and after dispatching fetchByCustomer 
  //we were setting initialChargersByCustomer but it is not guaranted that chargerListByCustomer has values setting the initialChargerByCustomers to null
  // hence remove the initialChargerByCustomer and all its dependent are now dependent on chargerListByCustomer
    // setInitialChargerByCustomer(chargerListByCustomer)
  });

  useEffect(() => {
    loadInitialData()
  }, [individualUserDetail])

  useEffect(() => {
    if (selectedChargers) {
      const formData = cloneDeep(userFormData);
      formData.chargerIds = selectedChargers;
      setUserFormData(formData)
    }
  }, [selectedChargers]);

  useEffect(() => {
    if (selectedAcChargers) {
      const formData = cloneDeep(userFormData);
      formData.acChargerIds = selectedAcChargers;
      setUserFormData(formData)
    }
  }, [selectedAcChargers]);

  useEffect(() => {
    if (dataList?.length > 0) {
      setChargersChipValues(chargerCheckboxStates);
      setIsSelectAllChargersChecked(chargerCheckboxStates?.length == dataList?.filter((item) => !item.endsWith(')'))?.length)
    }
  }, [dataList])



  useEffect(() => {
    if (acDataList?.length > 0) {
      setAcChargersChipValues(acChargerCheckboxStates);
      setIsSelectAllAcChargersChecked(acChargerCheckboxStates?.length == acDataList?.filter((item) => !item.endsWith(')'))?.length)
    }
  }, [acDataList])



  useEffect(() => {
    const chargerData = chargerListByCustomerByOrg?.map((item) => {
      return {
        header: item?.customerName,
        count: item?.chargers?.length,
        data: item?.chargers?.map((charger) => charger?.visibleId)
      }
    }) || []
    const dataList = chargerData?.flatMap(({ header, count, data }) => [
      (header !== undefined && count !== undefined) ? `${header} (${count})` : '',
      ...data
    ]).filter(item => item !== '');
    const uniqueDataList = Array.from(new Set(dataList));


    setDataList(uniqueDataList)


  }, [chargerListByCustomerByOrg])

  useEffect(() => {
    const acChargerData = acChargerListByCustomerByOrg?.map((item) => {
      return {
        header: item?.customerName,
        count: item?.chargers?.length,
        data: item?.chargers?.map((charger) => charger?.visibleId)
      }
    }) || []
    const acDataList = acChargerData?.flatMap(({ header, count, data }) => [
      (header !== undefined && count !== undefined) ? `${header} (${count})` : '',
      ...data
    ]).filter(item => item !== '');
    const uniqueAcDataList = Array.from(new Set(acDataList));
    setAcDataList(uniqueAcDataList)

  }, [acChargerListByCustomerByOrg])


  const loadInitialData = () => {
    if (individualUserDetail) {
      const userDetail = {
        name: individualUserDetail?.name,
        countryCode: individualUserDetail?.countryCode,
        mobileNumber: individualUserDetail?.mobileNumber ? individualUserDetail?.countryCode + individualUserDetail?.mobileNumber : individualUserDetail?.mobileNumber,
        emailId: individualUserDetail?.emailId,
        addressLine1: individualUserDetail?.addressLine1,
        addressLine2: individualUserDetail?.addressLine2,
        pinCode: individualUserDetail?.pinCode,
        city: individualUserDetail?.city,
        state: individualUserDetail?.state,
        org: {
          id: individualUserDetail?.orgId,
          value: individualUserDetail?.orgId,
          label: individualUserDetail?.orgName,
          name: individualUserDetail?.orgName,
        },
        role: {
          id: individualUserDetail?.roleId,
          value: individualUserDetail?.roleId,
          label: individualUserDetail?.roleName,
          name: individualUserDetail?.roleName,
        },
        chargerIds: individualUserDetail?.chargers? [...individualUserDetail.chargers] : [],
        acChargerIds:  individualUserDetail?.acChargers? [...individualUserDetail.acChargers] : [],
        status: individualUserDetail?.status ?? 'Inactive',
        notes: individualUserDetail?.notes,
        autoAssign: individualUserDetail?.autoAssign ?? 'Disabled',
        accessToModules: moduleAccessReferenceData?.filter(item => individualUserDetail?.accessToModules?.split(',')?.includes(item?.value)),
        accessToAcAndDc : accessToAcAndDcReferenceData?.find(item => item?.value === individualUserDetail?.accessToAcAndDc) || null,
      }
      setUserFormData((previous) => {
        const userFormToUpdate = cloneDeep(previous)
        const newFormData = {
          ...userFormToUpdate,
          ...userDetail
        }
        initialFormDataRef.current = newFormData
        return newFormData
      })
      setSelectedRadioOption(individualUserDetail?.chargerSelectMode ?? 'SelectChargers')
      setAcSelectedRadioOption(individualUserDetail?.acChargerSelectMode ?? 'SelectChargers')
      setChargerCheckboxStates(individualUserDetail?.chargers? [...individualUserDetail.chargers] : [])
      setAcChargerCheckboxStates(individualUserDetail?.acChargers ? [...individualUserDetail.acChargers] : [])
      setSelectedChargers(individualUserDetail?.chargers? [...individualUserDetail.chargers] : []);
      setAcSelectedChargers(individualUserDetail?.acChargers? [...individualUserDetail.acChargers] : [])
      setChargersChipValues((individualUserDetail?.chargers? [...individualUserDetail.chargers] : []));
      setAcChargersChipValues((individualUserDetail?.acChargers? [...individualUserDetail.acChargers] : []))
      setIsSelectAllChargersChecked(individualUserDetail?.chargers?.length == dataList?.filter((item) => !item.endsWith(')'))?.length)
      setIsSelectAllAcChargersChecked(individualUserDetail?.acChargers?.length == acDataList?.filter((item) => !item.endsWith(')'))?.length)
    }
  }

  // BELOW METHOD UPDATE THE FORM DATA AND SELECTED CHIPS WITH SELECTED CHARGERS....
  const handleSelectedValues = (selectedChargers, selectedChargerChips, isChecked) => {
    setChargerCheckboxStates(selectedChargers)
    setSelectedChargers(selectedChargers);
    setChargersChipValues(selectedChargerChips);
    setIsSelectAllChargersChecked(isChecked);
  };

const handleAcSelectedValues = (selectedChargers, selectedChargerChips, isChecked) => {
    setAcChargerCheckboxStates(selectedChargers)
    setAcSelectedChargers(selectedChargers);
    setAcChargersChipValues(selectedChargerChips);
    setIsSelectAllAcChargersChecked(isChecked);
  };

  const handleFormDataChange = useCallback((val, formKey, mobileDialCode?) => {
    const formData = cloneDeep(userFormData);
    formData[formKey] = val;
    if (formKey === 'mobileNumber') formData['countryCode'] = mobileDialCode
    // IF ORG IS CHANGED THEN CLEAR SELECTED ROLE AND SELECTED CHARGERS IF ANY
    if (formKey === 'org') {
      formData['role'] = null
      handleSelectedValues([], [], false)
      handleAcSelectedValues([], [], false)
    }
    setUserFormData(formData);
  }, [userFormData]);

  const disableSubmitButton = useCallback(() => {
    userFormData.chargerIds?.sort();
    if (mode === 'Edit' && isEqual(userFormData,initialFormDataRef?.current)) {
      return true
    }
    const mobileEntered = userFormData?.mobileNumber?.slice(userFormData?.countryCode?.length)?.length > 0;
    const emailEntered = userFormData?.emailId?.length > 0;
    const platformAccessRequired = (access?.isSuperAdmin() && access?.acAndDcAccess() == 'All') ? !!userFormData?.accessToAcAndDc : true;
    return !(userFormData?.name?.length > 0 && (mobileEntered || emailEntered) && mobileError?.length == 0 && userFormData?.org?.id && userFormData?.role?.id && platformAccessRequired /* && userFormData?.chargerIds?.length > 0 && !(userFormData?.chargerIds?.includes('ALL') && selectedRadioOption === 'SelectChargers') */);
  }, [userFormData, selectedRadioOption,acselectedRadioOption, mode, initialFormDataRef?.current]);

  const userFormSuccessToast = (): Id => toast.success(mode === 'Edit' ? 'User edited.' : 'User added.');
  const userFormErrorToast = (message): Id => toast.error(message);
  //TODO: FORM FOOTER BUTTONS ******
  const footerButtonList = useMemo(() => {
    return [
      {
        buttonText: mode === 'Edit' ? 'Update' : 'Add',
        buttonId: 'submit',
        btnClassName: disableSubmitButton() ? 'primary__btn disabled' : 'primary__btn',
        handleClick: (): void => {
          handleSubmit?.(mode)
        },
        isDisabled: disableSubmitButton(),
        buttonVariant: 'filled',
      },
      {
        buttonText: 'Cancel',
        buttonId: 'cancel',
        btnClassName: 'secondary__btn',
        handleClick: (): void => {
          navigate('/ac/manage-users')
        },
        isDisabled: false,
        buttonVariant: 'outlined',
      },
    ];
  }, [disableSubmitButton, userFormData, mode,initialFormData, selectedRadioOption,acselectedRadioOption]);

  // Profile Info *******************************

  const profileInfoFormArray: IFormContentProp[] = [
    {
      rowCountClassName: 'grid-3',
      sectionHeading: 'Profile',
      formObject: [
        {
          formLabel: 'Name',
          isRequired: true,
          objectType: 'input',
          selectDropdownProps: null,
          inputProps: {
            inputPlaceHolder: 'Enter Username',
            handleInputChange: (event): void => {
              handleFormDataChange(checkValidAlphabetDashDot(event?.target?.value), 'name');
            },
            inputValue: userFormData?.name,
            inputType: 'string',
            inputFieldId: 'add_user_name',
            isRequired: false,
            isDisabled: mode === 'View',
            autoFocus: true,
            handleKeyPress:keyPressValidationAlphabetDashDot
          },
          textAreaProps: null,
        },
        {
          formLabel: 'Mobile Number',
          isRequired: !userFormData?.emailId?.length,
          objectType: 'mobile-number',
          selectDropdownProps: null,
          onMobileNumberChange: (value, countryCode, dialCode): void => {
            const isValidMobileNumber = isValidPhoneNumber(`+${value}`, countryCode);
            if (!isValidMobileNumber && value?.slice(dialCode?.length)?.length > 0) {
              setMobileError('Please enter a valid mobile number.')
            } else {
              setMobileError('')
            }
            handleFormDataChange(value, 'mobileNumber', dialCode);
          },
          inputProps: {
            className: 'user__form-mobile-input',
            errorMessage: mobileError,
            inputValue: userFormData?.mobileNumber ?? '',
            inputFieldId: 'add_user_mobile_number',
            isRequired: false,
            isDisabled: mode === 'View'
          },
          textAreaProps: null,
        },
        {
          formLabel: 'Email Address',
          isRequired: !(userFormData?.mobileNumber?.slice(userFormData?.countryCode?.length)?.length > 0),
          objectType: 'input',
          selectDropdownProps: null,
          inputProps: {
            inputPlaceHolder: mode !== 'View' ? 'Enter Email' : '',
            handleInputChange: (event): void => {
              handleFormDataChange(event?.target?.value, 'emailId');
            },
            inputValue: userFormData?.emailId ?? '',
            inputType: 'string',
            inputFieldId: 'add_user_email',
            isRequired: false,
            isDisabled: mode === 'View'
          },
          textAreaProps: null,
        },
      ],
    },
    {
      rowCountClassName: 'grid',
      formObject: [
        {
          formLabel: 'Address',
          isRequired: false,
          objectType: 'input',
          selectDropdownProps: null,
          inputProps: {
            inputPlaceHolder: mode !== 'View' ? 'Enter Address Line 1' : '',
            handleInputChange: (event): void => {
              handleFormDataChange(checkValidAlphaNumericAndMoreSpecialSymbolsWithSpaces(event?.target?.value), 'addressLine1');
            },
            inputValue: userFormData?.addressLine1,
            inputType: 'string',
            inputFieldId: 'user__form-addressLine1',
            isRequired: false,
            isDisabled: mode === 'View',
            handleKeyPress:keyPressValidationAlphaNumericAndMoreSpecialSymbolsWithSpaces

          },
          textAreaProps: null,
        }
      ]
    },
    {
      rowCountClassName: 'grid',
      formObject: [
        {
          formLabel: '',
          isRequired: false,
          objectType: 'input',
          selectDropdownProps: null,
          inputProps: {
            inputPlaceHolder: mode !== 'View' ? 'Enter Address Line 2' : '',
            handleInputChange: (event): void => {
              handleFormDataChange(checkValidAlphaNumericAndMoreSpecialSymbolsWithSpaces(event?.target?.value), 'addressLine2');
            },
            inputValue: userFormData?.addressLine2,
            inputType: 'string',
            inputFieldId: 'user__form-addressLine2',
            isRequired: false,
            isDisabled: mode === 'View',
            handleKeyPress:keyPressValidationAlphaNumericAndMoreSpecialSymbolsWithSpaces
          },
          textAreaProps: null,
        }
      ]
    },
    {
      rowCountClassName: 'grid-4',
      formObject: [
        {
          formLabel: 'City',
          isRequired: false,
          objectType: 'input',
          selectDropdownProps: null,
          inputProps: {
            inputPlaceHolder: mode !== 'View' ? 'Enter City' : '',
            handleInputChange: (event): void => {
              handleFormDataChange(checkValidAlphaNumericOnly(event?.target?.value), 'city');
            },
            inputValue: userFormData?.city,
            inputType: 'string',
            inputFieldId: 'user__form-city',
            isRequired: false,
            isDisabled: mode === 'View',
            handleKeyPress: keyPressValidationAlphaNumericOnly,
          },
          textAreaProps: null,
        },
        {
          formLabel: 'State',
          isRequired: false,
          objectType: 'input',
          selectDropdownProps: null,
          inputProps: {
            inputPlaceHolder: mode !== 'View' ? 'Enter State' : '',
            handleInputChange: (event): void => {
              handleFormDataChange(checkCharactersPaste(event?.target?.value), 'state');
            },
            inputValue: userFormData?.state,
            inputType: 'string',
            inputFieldId: 'user__form-state',
            isRequired: false,
            isDisabled: mode === 'View',
            handleKeyPress: keyPressValidationForCharacters
          },
          textAreaProps: null,
        },
        {
          formLabel: 'PIN Code',
          isRequired: false,
          objectType: 'input',
          selectDropdownProps: null,
          inputProps: {
            inputPlaceHolder: mode !== 'View' ? 'Enter PIN Code' : '',
            handleInputChange: (event): void => {
              handleFormDataChange(checkPINCodePaste(event), 'pinCode');
            },
            inputValue: userFormData?.pinCode,
            inputType: 'string',
            inputFieldId: 'user__form-pinCode',
            isRequired: false,
            isDisabled: mode === 'View',
            handleKeyPress: keyPressValidationForPINCode
          },
          textAreaProps: null,
        },
      ]
    },
    {
      rowCountClassName: 'grid-3',
      formObject: [
        {
          formLabel: 'Organisation',
          isRequired: true,
          objectType: 'dropdown',
          selectDropdownProps: {
            selectValue: userFormData?.org,
            selectOptions: removeAllFromReferenceData(orgReferenceData) as IGeneralReferenceData[] || [],
            handleSelectOptionChange: (val): void => {
              handleFormDataChange(val, 'org');
              chargerListCallback?.(val?.id)
              acChargerListCallback?.(val?.id)
              dispatch(fetchUserRoleTypeReferenceData({ orgId: val?.id }));
            },
            selectDropDownId: 'user-role-type-dropdown',
            selectDropDownName: 'user-role-type-dropdown',
            isDisabled: mode !== 'Add',
            renderToBody: true
          },
          inputProps: null,
          textAreaProps: null,
        },
        {
          formLabel: 'Role',
          isRequired: true,
          objectType: 'dropdown',
          selectDropdownProps: {
            selectValue: userFormData?.role,
            selectOptions: removeAllFromReferenceData(userRoleTypeReferenceData) as IGeneralReferenceData[] || [],
            handleSelectOptionChange: (val): void => {
              handleFormDataChange(val, 'role');
            },
            selectDropDownId: 'user__form-role-dropdown',
            selectDropDownName: 'user__form-role-dropdown',
            isDisabled: mode === 'View' || individualUserDetail?.enableRoleEdit === 'Disabled',
            renderToBody: true
          },
          inputProps: null,
          textAreaProps: null,
        },
        {
          formLabel: 'Custom Feature Access',
          isRequired: false,
          objectType: 'dropdown',
          isAccessible: access?.users?.edit() && access?.userLevelAccess?.edit(),
          selectDropdownProps: {
            selectValue: userFormData?.accessToModules,
            selectOptions: removeAllFromReferenceData(moduleAccessReferenceData?.filter(item=>item.id!='moduleAccessProvider:*')) as IGeneralReferenceData[] || [],
            handleSelectOptionChange: (val): void => {
              handleFormDataChange(val, 'accessToModules');
            },
            selectDropDownId: 'user__form-access-to-modules-dropdown',
            selectDropDownName: 'user__form-access-to-modules-dropdown',
            isDisabled: mode === 'View' || individualUserDetail?.enableUserLevelAccessEdit === 'Disabled',
            renderToBody: true,
            isMultiSelect: true
          },
          inputProps: null,
          textAreaProps: null,
        },
        {
          formLabel: 'Platform Access',
          isRequired: (access?.isSuperAdmin() && access?.acAndDcAccess() == 'All'),
          objectType: 'dropdown',
          isAccessible: (access?.isSuperAdmin() && access?.acAndDcAccess() == 'All'),
          selectDropdownProps: {
            selectValue: userFormData?.accessToAcAndDc,
            selectOptions: (accessToAcAndDcReferenceData) as IGeneralReferenceData[] || [],
            handleSelectOptionChange: (val): void => {
              handleFormDataChange(val, 'accessToAcAndDc');
            },
            selectDropDownId: 'user__form-access-to-modules-dropdown',
            selectDropDownName: 'user__form-access-to-modules-dropdown',
            isDisabled: mode === 'View' || individualUserDetail?.enableUserLevelAccessEdit === 'Disabled',
            renderToBody: true,
            isMultiSelect: false
          },
          inputProps: null,
          textAreaProps: null,
        },
      ],
    },
    {
      rowCountClassName: '',
      formObject: [
        {
          formLabel: 'Notes',
          isRequired: false,
          objectType: 'text-area',
          selectDropdownProps: null,
          inputProps: null,
          textAreaProps: {
            inputPlaceHolder: mode !== 'View' ? 'Type here' : '',
            handleInputChange: (event): void => {
              handleFormDataChange(event?.target?.value, 'notes');
            },
            isRequired: false,
            inputValue: userFormData?.notes ?? '',
            inputFieldId: 'user__form-notes',
            isDisabled: mode === 'View'
          },
        },
      ],
    },
  ];

  const profileInfoFormProps: ICustomFormProps = useMemo(() => {
    return {
      formContainerClassName: 'user__form__profile__info',
      formArray: profileInfoFormArray
    };
  }, [userFormData, orgReferenceData, userRoleTypeReferenceData, mode])

  // TODO: Radio Button Configurations **********************************
  const radioButtonList = [
    { radioButtonLabel: 'All Chargers', radioButtonId: 'AllChargers', isDisabled: mode === 'View' },
    { radioButtonLabel: 'Select Chargers', radioButtonId: 'SelectChargers', isDisabled: mode === 'View' },
  ]

  const handleRadioOptionChange = (event, value) => {

    setSelectedRadioOption(value);
    if (value === 'AllChargers') setSelectedChargers(['ALL'])
    else { setSelectedChargers(chargerCheckboxStates) }
  };

   const handleAcRadioOptionChange = (event, value) => {
    setAcSelectedRadioOption(value);
    if (value === 'AllChargers') setAcSelectedChargers(['ALL'])
    else { setAcSelectedChargers(acChargerCheckboxStates) }
  };



  const  radioButtonConfiguration = useMemo(() => {
    return {
      radionBtnGrpName: 'user__form_charger_options',
      buttonsList: radioButtonList,
      selectedRadioBtnValue: selectedRadioOption,
      handleSelectedRadioBtnChange: handleRadioOptionChange
    };
  }, [userFormData, mode, selectedRadioOption, chargerCheckboxStates]);


  const  acRadioButtonConfiguration = useMemo(() => {
    return {
      radionBtnGrpName: 'user__form_charger_options',
      buttonsList: radioButtonList,
      selectedRadioBtnValue: acselectedRadioOption,
      handleSelectedRadioBtnChange: handleAcRadioOptionChange
    };
  }, [userFormData, mode, acselectedRadioOption, acChargerCheckboxStates]);

  //TODO: Search Box Configuration *****
  const onSearchTextChange = useCallback((val) => {
    chargerListCallback?.(userFormData?.org?.id, filters, val)
  }, [filters, userFormData])

  const searchBoxConfiguration = useMemo(() => {
    return {
      searchFieldId: 'user__form_chargers-search-box',
      searchFieldName: 'user__form_chargers-search-box',
      isDisabled: mode === 'View',
      handleSearch: onSearchTextChange,
    };
  }, [onSearchTextChange, filters, userFormData, mode]);


  const onAcSearchTextChange = useCallback((val) => {
      acChargerListCallback?.(userFormData?.org?.id, acFilters, val)
    }, [acFilters, userFormData])

  const AcSearchBoxConfiguration = useMemo(() => {
      return {
        searchFieldId: 'user__form_chargers-search-box',
        searchFieldName: 'user__form_chargers-search-box',
        isDisabled: mode === 'View',
        handleSearch: onAcSearchTextChange,
      };
    }, [onAcSearchTextChange, acFilters, userFormData, mode]);



  // TODO: CHARGER LIST BY CUSTOMER CALLBACK *****
  const chargerListCallback = useCallback((orgId, filters?, searchTerm?) => {
    let filtersToBeSent: Filters[] = []
    if (filters && filters?.length > 0) {
      filtersToBeSent = filters?.map((item) => {
        return {
          key: item.key,
          values: item.value?.map((item) => item.id) || []
        }
      })
    }
    dispatch(fetchChargersByCustomersByOrg({
      orgId: orgId ? orgId : userFormData?.org?.id,
      filters: filters ? filtersToBeSent : [],
      searchTerm: searchTerm != null && searchTerm != undefined ? searchTerm : ''
    }));

  }, [userFormData])

    const acChargerListCallback = useCallback((orgId, filters?, searchTerm?) => {
    let filtersToBeSent: Filters[] = []
    if (filters && filters?.length > 0) {
      filtersToBeSent = filters?.map((item) => {
        return {
          key: item.key,
          values: item.value?.map((item) => item.id) || []
        }
      })
    }
    dispatch(fetchAcChargersByCustomersByOrg({
      orgId: orgId ? orgId : userFormData?.org?.id,
      filters: filters ? filtersToBeSent : [],
      searchTerm: searchTerm != null && searchTerm != undefined ? searchTerm : ''
    }));

  }, [userFormData])

  //  TODO: CHARGERS FILTERS *****
  const handleFilterDataChange = useCallback((val, filterkey) => {
    const filtersToUpdate = cloneDeep(filters);
    const selectedFilter = filtersToUpdate?.find((filter) => filter?.key === filterkey);
    if (selectedFilter) {
      selectedFilter.value = Array.isArray(val) ? val : [val]
    }
    setFilters(filtersToUpdate);
    chargerListCallback?.(userFormData?.org?.id, filtersToUpdate, '')
  }, [filters, chargerListCallback, setFilters, userFormData])


    const handleAcFilterDataChange = useCallback((val, filterkey) => {
    const filtersToUpdate = cloneDeep(acFilters);
    const selectedFilter = filtersToUpdate?.find((filter) => filter?.key === filterkey);
    if (selectedFilter) {
      selectedFilter.value = Array.isArray(val) ? val : [val]
    }
    setAcFilters(filtersToUpdate);
    acChargerListCallback?.(userFormData?.org?.id, filtersToUpdate, '')
  }, [acFilters, acChargerListCallback, setAcFilters, userFormData])

  const chargerFilterProps: FilterProp[] = useMemo(() => {
    return [
      {
        filterLabel: 'Customer',
        filterType: 'dropdown',
        filterId: 'Customer',
        filterDropdownProps: {
          selectValue: filters?.find((filter) => filter?.key === 'customer')?.value,
          selectOptions: customerReferenceData ?? [],
          handleSelectOptionChange: (val): void => {
            handleFilterDataChange(val, 'customer')
          },
          selectDropDownId: 'charger-customer-filter-dropdown',
          isMultiSelect: true,
          isDisabled: mode === 'View',
          renderToBody: true
        }
      },
      {
        filterLabel: 'Location',
        filterType: 'dropdown',
        filterId: 'Location',
        filterDropdownProps: {
          selectValue: filters?.find((filter) => filter?.key === 'location')?.value,
          selectOptions: chargerLocationReferenceData ?? [],
          handleSelectOptionChange: (val): void => {
            handleFilterDataChange(val, 'location')
          },
          selectDropDownId: 'charger-location-filter-dropdown',
          isMultiSelect: true,
          isDisabled: mode === 'View',
          renderToBody: true
        }
      },
    ]
  }, [chargerLocationReferenceData, customerReferenceData, filters, mode, userFormData])

  const acChargerFilterProps: FilterProp[] = useMemo(() => {

    return [
      {
        filterLabel: 'Customer',
        filterType: 'dropdown',
        filterId: 'Customer',
        filterDropdownProps: {
          selectValue: acFilters?.find((filter) => filter?.key === 'customer')?.value,
          selectOptions: acCustomerReferenceData ?? [],
          handleSelectOptionChange: (val): void => {
            handleAcFilterDataChange(val, 'customer')
          },
          selectDropDownId: 'charger-customer-filter-dropdown',
          isMultiSelect: true,
          isDisabled: mode === 'View',
          renderToBody: true
        }
      },
      {
        filterLabel: 'Location',
        filterType: 'dropdown',
        filterId: 'Location',
        filterDropdownProps: {
          selectValue: acFilters?.find((filter) => filter?.key === 'location')?.value,
          selectOptions: acChargerLocationReferenceData ?? [],
          handleSelectOptionChange: (val): void => {
            handleAcFilterDataChange(val, 'location')
          },
          selectDropDownId: 'charger-location-filter-dropdown',
          isMultiSelect: true,
          isDisabled: mode === 'View',
          renderToBody: true
        }
      },
    ]
  }, [acChargerLocationReferenceData, acCustomerReferenceData, filters, mode, userFormData])



  //TODO: SUBMIT FORM *******
  const handleSubmit = useCallback(async (mode) => {
    setShowLoader(true)
    let chargerIds: string[] = userFormData?.chargerIds
    let acChargerIds: string[] = userFormData?.acChargerIds
    if (userFormData?.chargerIds?.length > 0 && !userFormData?.chargerIds?.includes('ALL')) {
      chargerIds = findChargerIdByVisibleId(userFormData?.chargerIds);
    }
    if (userFormData?.acChargerIds?.length > 0 && !userFormData?.acChargerIds?.includes('ALL')) {
      acChargerIds = findAcChargerIdByVisibleId(userFormData?.acChargerIds);
    }
    const mobileDigits = userFormData?.mobileNumber?.slice(userFormData?.countryCode?.length);

    const reqBody = {
      id: mode === 'Edit' ? location?.state?.userId : null,
      name: userFormData?.name,
      countryCode: mobileDigits?.length > 0 ? (userFormData?.countryCode?.includes('+') ? userFormData?.countryCode : '+' + userFormData?.countryCode) : null,
      mobileNumber: mobileDigits?.length > 0 ? mobileDigits : null,
      emailId: userFormData?.emailId || null,
      addressLine1: userFormData?.addressLine1,
      addressLine2: userFormData?.addressLine2,
      pinCode: userFormData?.pinCode,
      city: userFormData?.city,
      state: userFormData?.state,
      orgId: userFormData?.org?.id,
      roleId: userFormData?.role?.id,
      chargerIds: (userFormData?.accessToAcAndDc && userFormData.accessToAcAndDc.value!='AC') || (access?.acAndDcAccess() == 'DC') ? chargerIds : [],
      acChargerIds: (userFormData?.accessToAcAndDc && userFormData.accessToAcAndDc.value!='DC') || (access?.acAndDcAccess() == 'AC') ? acChargerIds : [],
      status: userFormData?.status,
      chargerSelectMode: selectedRadioOption,
      acChargerSelectMode: acselectedRadioOption,
      notes: userFormData?.notes,
      autoAssign: userFormData?.autoAssign,
      accessToModules: userFormData?.accessToModules && userFormData?.accessToModules?.length > 0 ? userFormData?.accessToModules?.map(item=>item?.value)?.join(',') : null,
      accessToAcAndDc : (access?.isSuperAdmin() && access?.acAndDcAccess() == 'All') ? userFormData?.accessToAcAndDc ? userFormData.accessToAcAndDc.value : null : access?.acAndDcAccess(),
    }
    

    let response: AxiosResponse
    if (mode === 'Edit') {
      response = await dispatch(updateUser(reqBody))
    } else {
      response = await dispatch(createUser(reqBody))
    }
    if ((response?.status === 200 || response?.status === 202) && response?.data?.message === 'Success') {
      setShowLoader(false)
      userFormSuccessToast();
      navigate('/ac/manage-users')
    } else {
      setShowLoader(false)
      userFormErrorToast(response?.data?.message);
    }
  }, [userFormData, mode,selectedRadioOption,acselectedRadioOption,chargerListByCustomer,acChargerListByCustomer])

  // TODO: Helper to find charger Ids from selected Visible Ids
  const findChargerIdByVisibleId = useCallback((chargerVisibleIds) => {
    const chargeIds: string[] = [];
    chargerListByCustomer?.forEach(customer => {
      customer?.chargers.forEach(charger => {
        if (chargerVisibleIds?.includes(charger?.visibleId)) {
          chargeIds.push(charger?.id);
        }
      });
    });
    return chargeIds;
  }, [chargerListByCustomer])


  const findAcChargerIdByVisibleId = useCallback((chargerVisibleIds) => {
    const acChargeIds: string[] = [];
    acChargerListByCustomer?.forEach(customer => {
      customer?.chargers.forEach(charger => {
        if (chargerVisibleIds?.includes(charger?.visibleId)) {
          acChargeIds.push(charger?.id);
        }
      });
    });
    return acChargeIds;
  }, [acChargerListByCustomer])


  // TODO: BreadCrumb navigation Props
  const breadCrumbs = createBreadCrumbProps({
    breadCrumbProps:
      [
        {
          objectType: 'link',
          id: 'users',
          link: '/ac/manage-users'
        },
        {
          objectType: 'text',
          id: 'text',
          text: mode !== 'Add' ? userFormData?.name : `${mode} User`
        }
      ]
  })

  // TODO: FORM HEADER TEXT *****
  const setHeaderText = useCallback(() => {
    return mode !== 'Add' ? userFormData?.name : `${mode} User`
  }, [mode, userFormData])

  // TODO: Redux state Clean up
  const userFormCleanUpStates = useCallback(() => {
    const action = {
      type: userTypes.CLEAR_USER_DETAIL_DATA,
    }
    dispatch(action);
  }, [])

  useEffect(() => {
    window.addEventListener('beforeunload', userFormCleanUpStates);
    return (): void => {
      userFormCleanUpStates()
      window.removeEventListener('beforeunload', userFormCleanUpStates);
    }
  }, [])



       
  const toolTipText = userFormData?.status === 'Active' ? 'Active user will be able to access the RMS Platform.' : 'Inactive user will not be able to access the RMS Platform.';






  useEffect(() => {
  const access = userFormData?.accessToAcAndDc?.value;

  if (access === 'AC') setSelectedNav('AC');
  if (access === 'DC') setSelectedNav('DC');

}, [userFormData?.accessToAcAndDc]);


const handleAcAndDcToggle =(val: 'AC' | 'DC') => {
    setSelectedNav(val)
  };


  return (
		<>
			<DashboardLoader showLoader={showLoader} />
			<div className='user__form__wrap'>
				<CustomBreadCrumbs breadCrumbs={breadCrumbs} />
				<div className='user__form__wrap-header'>
					<DashboardHeader
						header={setHeaderText()}
						headerClassName='user__form__wrap-header-text'
					/>
					{mode !== 'Add' && access?.users?.edit() && (
						<Icon
							iconClassName={
								mode === 'View' ? 'rms__pencil__icon' : 'rms__view__icon'
							}
							containerClassName='user__form_header-edit'
							onIconClick={() => {
								if (mode === 'Edit') loadInitialData();
								setMode(mode === 'View' ? 'Edit' : 'View');
							}}
						/>
					)}
					<IconWithTooltip
						iconClassName='rms_info_icon-black'
						toolTipText={toolTipText}
						containerClassName='user__form_header-status-info'
					/>
					<CustomSwitch
						switchId='user__form__status-switch'
						switchClassName='user__form__status-switch'
						checked={userFormData?.status === 'Active'}
						//switchLabelName='Active'
						disableSwitchLabelName={
							userFormData?.status === 'Inactive' ? 'Inactive' : 'Active'
						}
						handleClick={() => {
							handleFormDataChange(
								userFormData?.status === 'Active' ? 'Inactive' : 'Active',
								'status',
							);
						}}
						isDisabled={mode === 'View'}
					/>
				</div>
				<div className='user__form__wrap-content'>
					<CustomForm {...profileInfoFormProps} />
					{
            access?.acAndDcAccess() === 'All' && <div className='ac-dc-toggle-charger-btn'>
						{userFormData?.accessToAcAndDc?.value === 'All' ? (
							<ACDCToggle
								selected={selectedNav}
								onChange={() => {
									handleAcAndDcToggle(selectedNav === 'DC' ? 'AC' : 'DC');
								}}
							/>
						) : (
							<div className={userFormData?.accessToAcAndDc?.value ? 'toggle-btn' : ''}>
								{userFormData?.accessToAcAndDc?.value ? userFormData?.accessToAcAndDc?.value : access.acAndDcAccess()}
							</div>
						)}
					</div>
          }

          {(
                    selectedNav === 'DC' && ( access?.acAndDcAccess() === 'All' || access?.acAndDcAccess() === 'DC' )
                  ) ? (
                    <>
                      {userFormData?.org?.id && (
                        <CustomRadioForm
                          key={selectedRadioOption}
                          formContainerClass={'user__form__charger-selection'}
                          header={'Access'}
                          dataList={dataList || []}
                          individualCheckboxStates={chargerCheckboxStates}
                          selectedChipValues={chargersChipValues}
                          selectAllChecked={isSelectAllChargersChecked}
                          handleSelectedData={handleSelectedValues}
                          filterProps={chargerFilterProps}
                          radioButtonConfiguration={radioButtonConfiguration}
                          searchBoxConfiguration={searchBoxConfiguration}
                          disableCheckBox={mode === 'View'}
                          showRadioList={selectedRadioOption === 'SelectChargers'}
                        />
                      )}
                    </>
                  ) : (
                    (selectedNav === 'AC'  && ( access?.acAndDcAccess() === 'All' || access?.acAndDcAccess() === 'AC' )) && (
                      <>
                        {userFormData?.org?.id && (
                          <CustomRadioForm
                            key={acselectedRadioOption}
                            formContainerClass={'user__form__charger-selection'}
                            header={'Access'}
                            dataList={acDataList || []}
                            individualCheckboxStates={acChargerCheckboxStates}
                            selectedChipValues={acChargersChipValues}
                            selectAllChecked={isSelectAllAcChargersChecked}
                            handleSelectedData={handleAcSelectedValues}
                            filterProps={acChargerFilterProps}
                            radioButtonConfiguration={acRadioButtonConfiguration}
                            searchBoxConfiguration={AcSearchBoxConfiguration}
                            disableCheckBox={mode === 'View'}
                            showRadioList={acselectedRadioOption === 'SelectChargers'}
                          />
                        )}
                      </>
                    )
            )}
				</div>
				<div className='user__form__wrap-footer'>
					{userFormData?.org?.id && (
						<div className='user__form__wrap-footer-top'>
							<div
								className='user__form__wrap-footer-top-checkbox'
								onClick={() => {
									mode !== 'View' &&
										handleFormDataChange(
											userFormData?.autoAssign === 'Enabled'
												? 'Disabled'
												: 'Enabled',
											'autoAssign',
										);
								}}
							>
								<CheckBox
									checked={userFormData?.autoAssign === 'Enabled'}
									isDisabled={mode === 'View'}
								/>
								Auto assign new charger to this user
							</div>
							<IconWithTooltip
								iconClassName='rms_info_icon-black'
								toolTipText={
									'RMS will automatically assign any new charger to this user.'
								}
								containerClassName='user__form_footer-auto-assign-info'
							/>
						</div>
					)}

					<CustomButtonGroup
						buttonsList={
							mode === 'View'
								? footerButtonList?.filter(
										(button) => button?.buttonId === 'cancel',
									)
								: footerButtonList
						}
						buttonGroupClassName='button__group__footer'
					/>
				</div>
			</div>
		</>
	);
};

export default AcUserForm;
